import { Amplify } from 'aws-amplify';

import { ENDPOINTS } from 'consts';
import { ApiNames } from 'types';

const {
  REACT_APP_REGION,
  REACT_APP_API_URL,
  REACT_APP_USER_POOL_ID,
  REACT_APP_IDENTITY_POOL_ID,
  REACT_APP_USER_POOL_CLIENT_ID,
  REACT_APP_UPLOADS_BUCKET,
} = process.env as Record<string, string>;

export const configureAmplify = () => {
  Amplify.configure({
    Auth: {
      Cognito: {
        allowGuestAccess: true,
        identityPoolId: REACT_APP_IDENTITY_POOL_ID,
        userPoolId: REACT_APP_USER_POOL_ID,
        userPoolClientId: REACT_APP_USER_POOL_CLIENT_ID,
      },
    },
    Storage: {
      S3: {
        region: 'us-east-1',
        bucket: REACT_APP_UPLOADS_BUCKET,
      },
    },

    API: {
      REST: (Object.keys(ENDPOINTS) as Array<ApiNames>).reduce((prev, curr) => {
        prev[curr] = {
          region: REACT_APP_REGION,
          endpoint: `${REACT_APP_API_URL}/${ENDPOINTS[curr]}`,
        };

        return prev;
      }, {} as Record<string, any>),
    },
  });
};
